/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { DisplayHtmlContent, Heading, toTitleCase } from 'sarsaparilla';

interface ListTypes {
    content: Array<{
        title: string;
        paragraphs: Array<string>;
    }>;
}
export default function List({ content }: ListTypes) {
    const headings: Record<string, string> = {
        'selecting-tree': 'Selecting Your Tree',
        'where-to-cut': 'Where to Cut Your Tree',
        'plan-trip': 'How to Plan your Trip',
        'cut-tips': 'Helpful Cutting tips',
    };
    return (
        <div className="tp-list">
            {content.map(({ title, paragraphs = [] }, i) => {
                const hasParagraphs = !!paragraphs?.length;

                return (
                    <div className="tp-list-item" key={i}>
                        {title && (
                            <Heading
                                appearance="small"
                                headingLevel={3}
                                className="tp-list-title"
                            >
                                {toTitleCase(headings[title])}
                            </Heading>
                        )}
                        {hasParagraphs && (
                            <div className="tp-list-content" key={i}>
                                <ul>
                                    {paragraphs.map((html: string, j: number) => {
                                        return (
                                            <li key={`${i}-${j}`}>
                                                <DisplayHtmlContent html={html} />
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
